import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { FormHelperText } from "@mui/material";
import axios from "axios";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { toast, ToastContainer } from "react-toastify";
import { IoMdOpen } from "react-icons/io";
import { ArrowBack } from "@mui/icons-material";
import Swal from "sweetalert2";
import { webBannerApi } from "../../app/slices/homeBanner/webBannerSlice";
import { useMediaQuery, useTheme } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";

export default function WebCarousal() {
  const dispatch = useDispatch();
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const [refresh, setRefresh] = useState(false);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [formData, setFormData] = useState({
    _id: null,
    title: "",
    active: 0, // Assuming you want to set a default status
    subtitle: "",
    buttonText: "",
    buttonLink: "",
    titleColor: "#442673",
    subtitleColor: "#442673",
    buttonBgColor: "#4A2A7D",
    buttonTextColor: "#FFFFFF",
    content: "",
    homebanner_upload: null, // this should be a File
  });
  const maxSize = 7 * 1024 * 1024;
  const allowedExtensions = ["png", "jpg", "webp"];
  const { validatedFile, error: fileError } = useFileTypeValidator(
    formData.web_banner,
    allowedExtensions,
    maxSize,
  );
  // console.log("formData:::::::::::::::::::::::::::::::::::::::::::", formData);

  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      active: "",
      title: "",
      subtitle: "",
      buttonText: "",
      buttonLink: "",
      titleColor: "#442673",
      subtitleColor: "#442673",
      buttonBgColor: "#4A2A7D",
      buttonTextColor: "#FFFFFF",
      content: "",
      homebanner_upload: null, // Reset the file input
    });
    // setIsEditMode(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (fileError) {
      toast.error(fileError);
      return;
    }
    setLoading(true);

    if (!formData?.web_banner) {
      await Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Web banner fields are required.",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });

      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("subtitle", formData.subtitle);
    formDataToSend.append("buttonText", formData.buttonText);
    formDataToSend.append("buttonLink", formData.buttonLink);
    formDataToSend.append("titleColor", formData.titleColor);
    formDataToSend.append("subtitleColor", formData.subtitleColor);
    formDataToSend.append("buttonBgColor", formData.buttonBgColor);
    formDataToSend.append("buttonTextColor", formData.buttonTextColor);
    formDataToSend.append("content", formData?.content);

    formDataToSend.append("web_banner", formData?.web_banner); // This should be a File object
    const headers = {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axiosInstance.post(
        `/upload_web_banner`,
        formDataToSend,
        {
          headers,
        },
      );
      // const response = await axios.post(
      //   `${baseUrl}/upload_web_banner`,
      //   formDataToSend,
      //   {
      //     headers,
      //   }
      // );

      if (response.data?.error === false) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Web Banner uploaded successfully!",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      }

      dispatch(webBannerApi());
      resetForm();
      setLoading(false);
    } catch (error) {
      console.error("Upload failed:", error);
      // toast?.error(error.response?.data || error.message);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message || "Upload failed",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
      setLoading(false);
    }
  };

  const handleDelete = async (rowData) => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    // console.log("token::::::::::::::::::;", headers)
    try {
      const response = await axiosInstance.delete(
        `/bannerDelete/${rowData._id}`,

        // {
        //   headers,
        // }
      );
      // const response = await axios.delete(
      //   `${baseUrl}/bannerDelete/${rowData._id}`,

      //   {
      //     headers,
      //   }
      // );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response?.data?.message || "Home Banner deleted successfully!",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });

      dispatch(webBannerApi());
      // remove the state after state is saved
    } catch (error) {
      // toast?.error("Error deleting home banner: " + error.message);
      await Swal.fire({
        icon: "error",
        title: "Error Deleting Banner",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    dispatch(webBannerApi());
  }, [dispatch, refresh]);

  const sliceResponse = useSelector((state) => state.webBanner.webBanner.data);

  // console.log("sliceResponse:::::::::::::::::::::::::::", sliceResponse);
  const stateLoading = useSelector((state) => state.webBanner.loading);
  const [open, setOpen] = useState(false);
  const [fullSubtitle, setFullSubtitle] = useState("");

  const handleStatusChange = async (id) => {
    try {
      const url = `/table/web_banner/toggle/${id}`;
      // const url = `${baseUrl}/table/web_banner/toggle/${id}`;
      const response = await axiosInstance.get(url, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Accept: "application/json",
        //   Authorization: `Bearer ${token}`,
        // },
      });
      // const response = await axios.get(url, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Accept: "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });

      if (response.data.error === false) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Status updated successfully!",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "Failed to update status!",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while updating status!",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("title", {
      header: "Title",
    }),

    columnHelper.accessor("subtitle", {
      header: "Subtitle",
      Cell: (cell) => {
        const subtitle = cell?.row?.original?.subtitle || "";

        const maxLength = 50;
        const isLong = subtitle.length > maxLength;
        const shortSubtitle = isLong
          ? `${subtitle.slice(0, maxLength)}...`
          : subtitle;

        const openFullSubtitleModal = () => {
          setOpen(true); // use your modal state
          setFullSubtitle(subtitle); // store subtitle in state
        };

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {isLong && (
              <Tooltip title="Show Full Subtitle">
                <IconButton onClick={openFullSubtitleModal}>
                  <IoMdOpen fontSize={"1rem"} color="black" />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={subtitle} arrow>
              <span>{shortSubtitle}</span>
            </Tooltip>
          </Box>
        );
      },
    }),

    columnHelper.accessor("buttonText", {
      header: "Button Text",
    }),
    columnHelper.accessor("buttonLink", {
      header: "Button Link",
      Cell: ({ cell }) => {
        const link = cell.getValue();
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            {link}
          </a>
        );
      },
    }),
    // columnHelper.accessor("imageUrl", {
    //   header: "Banner Image",
    //   Cell: ({ cell }) => {
    //     const fileUrl = cell.getValue();
    //     return fileUrl ? (
    //       <a
    //         href={fileUrl}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         style={{ color: "blue" }}
    //       >
    //         Open
    //       </a>
    //     ) : (
    //       "No File"
    //     );
    //   },
    // }),

    columnHelper.accessor("imageUrl", {
      header: "Banner Image",
      Cell: ({ cell }) => {
        const fileUrl = cell.getValue();

        return fileUrl ? (
          <Tooltip title="Click to view full image">
            <Box
              component="a"
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-block",
                width: 80,
                height: 50,
                overflow: "hidden",
                borderRadius: 1,
                border: "1px solid #ccc",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                },
              }}
            >
              <img src={fileUrl} alt="Preview" />
            </Box>
          </Tooltip>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No File
          </Typography>
        );
      },
    }),

    columnHelper.accessor("titleColor", {
      header: "Title Color",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("subtitleColor", {
      header: "Subtitle Color",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("buttonBgColor", {
      header: "Button BG",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("buttonTextColor", {
      header: "Button Text Color",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("content", {
      header: "Content",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),

    // columnHelper.accessor("active", {
    //   header: "Status",
    // }),
    columnHelper.accessor("active", {
      header: "Status",
      size: 30,
      // In your status toggle cell
      Cell: ({ cell }) => {
        const isActive = cell.getValue() == 0 ? true : false;
        const rowId = cell.row.original._id;

        const handleToggle = async () => {
          await handleStatusChange(rowId); // wait till backend updates
          setRefresh((prev) => !prev); // trigger UI re-render
        };

        return (
          <Switch
            checked={isActive}
            onChange={handleToggle}
            inputProps={{ "aria-label": "Status toggle" }}
          />
        );
      },
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
    columnHelper.accessor("Actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowData = cell?.row?.original;
        return (
          <>
            <Tooltip title="Delete">
              <IconButton onClick={() => handleDelete(rowData)}>
                <DeleteIcon color="error" sx={{ color: "red !important" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    }),
  ];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    <>
      <ToastContainer />
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Grid container spacing={2} justifyContent="center">
            {/* Row 1 */}

            {!isEditMode ? (
              <>
                {" "}
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Title"
                    variant="outlined"
                    fullWidth
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Subtitle"
                    variant="outlined"
                    fullWidth
                    name="subtitle"
                    value={formData.subtitle}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Button Text"
                    variant="outlined"
                    fullWidth
                    name="buttonText"
                    value={formData.buttonText}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Button Link"
                    variant="outlined"
                    fullWidth
                    name="buttonLink"
                    value={formData.buttonLink}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <Box>
                    <TextField
                      fullWidth
                      type="file"
                      id="file-input"
                      name="web_banner"
                      onChange={(e) => {
                        const file = e.target.files[0];

                        setFormData((prevData) => ({
                          ...prevData,
                          web_banner: file,
                        }));
                      }}
                      // inputProps={{ accept: ".jpg,.jpeg,.png,.webp" }}
                      // error={!!fileError}
                    />

                    {fileError ? (
                      <FormHelperText error>{fileError}</FormHelperText>
                    ) : (
                      <FormHelperText>
                        Allowed file type{" "}
                        {allowedExtensions
                          .map((format) => `.${format}`)
                          .join(", ")}{" "}
                        with max size {maxSize / (1024 * 1024)} MB
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Title Color"
                    variant="outlined"
                    fullWidth
                    name="titleColor"
                    type="color"
                    value={formData.titleColor}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Subtitle Color"
                    variant="outlined"
                    fullWidth
                    name="subtitleColor"
                    type="color"
                    value={formData.subtitleColor}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Button Background Color"
                    variant="outlined"
                    fullWidth
                    name="buttonBgColor"
                    type="color"
                    value={formData.buttonBgColor}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <TextField
                    label="Button Text Color"
                    variant="outlined"
                    fullWidth
                    name="buttonTextColor"
                    type="color"
                    value={formData.buttonTextColor}
                    onChange={handleChange}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={1}>
                  <Tooltip title="Back">
                    <IconButton
                      onClick={() => setIsEditMode(false)}
                      style={{
                        padding: "16px",
                        // border: "0px solid #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // gap: "8px",
                      }}
                    >
                      <ArrowBack />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Status"
                    variant="outlined"
                    fullWidth
                    name="active"
                    type="number"
                    value={formData.active}
                    onChange={handleChange}
                    inputProps={{ min: 0, max: 1 }}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={2.4}>
              <FormControl fullWidth>
                <InputLabel id="content-label">Content</InputLabel>
                <Select
                  labelId="content-label"
                  id="content"
                  name="content"
                  value={formData.content}
                  onChange={handleChange}
                  label="content"
                >
                  <MenuItem value="left">Left</MenuItem>
                  <MenuItem value="right">Right</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={isEditMode ? 5 : 2.4} textAlign="center">
              {loading ? (
                <Button
                  style={{ padding: "16px" }}
                  variant="contained"
                  color="primary"
                  disabled
                  sx={{ p: 1.5, width: "100%" }}
                >
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                </Button>
              ) : (
                <Button
                  style={{ padding: "16px" }}
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  sx={{ p: 1.5, width: "100%" }}
                >
                  Submit
                </Button>
              )}
            </Grid> */}
          </Grid>
          <Grid
            item
            xs={12}
            md={isEditMode ? 5 : 2.4}
            textAlign="center"
            justifyContent="flex-end"
            display="flex"
            mt={2}
          >
            {loading ? (
              <Button
                style={{ padding: "16px" }}
                variant="contained"
                color="primary"
                disabled
                sx={{ p: 1.5, width: isMobile ? "100%" : "19.1%" }}
              >
                <CircularProgress size={23} sx={{ color: "#fff" }} />
              </Button>
            ) : (
              <Button
                style={{ padding: "16px" }}
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{ p: 1.5, width: isMobile ? "100%" : "19.2%" }}
                // fullWidth
              >
                Submit
              </Button>
            )}
          </Grid>
        </CardContent>
      </Card>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="WebBanner"
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Full Subtitle Text :</DialogTitle>
        <DialogContent>
          <Typography>{fullSubtitle}</Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}
